import * as React from 'react';

interface SuccessProps {
    message: string;
    onClose: () => void;
}

export const Success = ({ message, onClose }: SuccessProps) => {
    return (
        <>
            <div className="modal-body">
            <div
                className="text-center">
                <p
                    style={{ fontSize: 100 + 'px' }}
                    className="text-center text-success">
                    <i
                        className="fa fa-check-circle"
                        aria-hidden="true"></i>
                </p>
                <p
                    className="text-center">{message}</p>
            </div>
        </div>
            <div className="modal-footer">
                <button className="btn btn-primary" onClick={onClose}>Close</button>
            </div>
        </>
    );
}
